import React, { useMemo } from 'react';
import { sanitizeRichHtml } from '../utils/sanitizeHtml';

interface RichTextContentProps {
  html: string;
  className?: string;
}

/**
 * Renders rich text HTML produced by the TipTap editor, sanitized with a
 * DOMPurify whitelist (the content is user input stored unfiltered).
 * Uses Tailwind prose classes for typography.
 */
export const RichTextContent: React.FC<RichTextContentProps> = ({ html, className = '' }) => {
  const veilig = useMemo(() => sanitizeRichHtml(html), [html]);
  return (
    <div
      className={`prose prose-sm max-w-none text-gray-800
        prose-headings:text-gray-900
        prose-a:text-[#0B1F3A] prose-a:underline
        prose-img:rounded-lg prose-img:max-w-full
        prose-ul:list-disc prose-ol:list-decimal
        prose-li:my-0.5
        prose-strong:font-bold
        prose-blockquote:border-l-4 prose-blockquote:border-[#0B1F3A] prose-blockquote:italic prose-blockquote:text-gray-500
        ${className}`}
      dangerouslySetInnerHTML={{ __html: veilig }}
    />
  );
};
